import React, {useContext} from 'react';
import {UserContext} from "@context/UserContext";
import ResponsiveRow from "@common/ResponsiveRow";
import TableAntD from "@common/TableAntD";
import {Collapse} from "antd";
import {ContentContext} from "@context/ContentContext";
import {BrandContext} from "@context/BrandContext";
import CircularLoader from "@common/CircularLoader";
const { Panel } = Collapse;

const StudentProgress = (props)=>{

    const {dataArray = [], columns, legends=[], loading = false} = props;

    const { user } = useContext(UserContext),
        {content} = useContext(ContentContext),
        brandConfig = useContext(BrandContext);

    return (
        <>
            <h2>{user.syllabusName}</h2>
            <ResponsiveRow items={legends} />
            <h3 className={'margin-l--s'}>{brandConfig.topicsName}</h3>
            {loading && <CircularLoader/>}
            {!loading && <ResponsiveRow items={[<Collapse defaultActiveKey={content.currentTopic?.topicId} className={'ch-collapse'} size="small" accordion>
                {dataArray.map((data)=>(
                    <Panel header={data.title} key={data.id}>
                        <TableAntD style={{paddingTop:0}} data={data.items} columnData={data.columns} />
                    </Panel>
                ))}
            </Collapse>]} />}
        </>
    )
}



export default StudentProgress;